module.exports = __webpack_public_path__ + "img/semi_rigide.63bc34b3.svg";